// import { useState } from "react";
// import AuthContext from '../../Context/AuthProvider';
import { useRef, useState, useEffect ,useContext} from 'react';
import {useLocation, useNavigate } from "react-router";
import { Link } from 'react-router-dom';
// import useAuth from '../hooks/useAuth';
// const from = location.state?.from?.pathname || "/";
import "./Login.css"
// import useAuth from "../../Hooks/UseAuth";
// import useAuth from "../../Hooks/useRefreshToken"
// import useAuth from '../../Hooks/UseAuth';
import useAuth from '../../Components/Hooks/UseAuth';
// import ClipLoader from "react-spinners/ClipLoader";
import BeatLoader from "react-spinners/BeatLoader";
// import axios from '../api/axios';
// import axios from '../../api/axios';
import axios from 'axios';
import img1 from "../../Images/UnilusPNG3.png"
import Footer from '../../Components/Footer/Footer';
const LOGIN_URL = '/auth';


// here


// import { Link, useNavigate, useLocation } from 'react-router-dom';

// import { Link,useLocation,useNavigate } from "react-router-dom";

function Login(){ 
 
 let navigate = useNavigate();
 // let navigate = useNavigate();
 let location = useLocation();
 // let location = useLocation();
 const [email, setEmail] = useState('');
 const [Fname, setFName] = useState('')
 const [Lname, setLName] = useState('')
 const [password, setPassword] = useState(''); 
 const [Gender, setGender] = useState(''); 
 // const [password, setPassword] = useState('nerd1234'); 
 const {setAuth, auth} = useAuth()
//  const { setAuth,auth } = useContext(AuthContext);
 const [signUp, setSignup] = useState(false); 
 const [loginState, setLogin] = useState(true); 
 const [register, setRegister] = useState(false);
 const [Branch, setBranch] = useState("");
 const [Phone, setPhone] = useState("");
 const [DOB, setDOB] = useState("");
 const [NRC, setNRC] = useState("");
 const [AccNo, setAccNo] = useState("");
 const [Loading, setLoading] = useState(false);
 const [errorMsg, setErrorMsg] = useState(false);
 const [Msg, setMsg] = useState("");
 const [successMsg, setSuccessMsg] = useState(false);
 const userRef = useRef();
 const errRef = useRef();
 const [OrgName, setOrgName] = useState("");
 const [forgotPwdState, setForgotPwdStaten] = useState(false); 
 const [sucessRecovery, setSucessRecovery] = useState(false); 
 const [selectedOption, setSelectedOption] = useState('');


 const [user, setUser] = useState('');
 const [pwd, setPwd] = useState('');
 const [errMsg, setErrMsg] = useState('') 
   
 const handleDropdownChange = (event) => {
   setSelectedOption(event.target.value);
};


 //
 
 // const [email, setEmail] = useState('')
 // const [password, setPassword] = useState('') 


 
 
 
 
 async function LoginUser(e) { 
 e.preventDefault(); 
 setLoading(true)
 setSuccessMsg(false);
 setErrorMsg(false);
 
 // const from = location?.state?.from?.pathname || "/UserDash";

 const response = await fetch("http://localhost:2001/api/authlogin",{ 
 // const response = await fetch("https://superagentback.onrender.com/api/login",{ 
 method : "POST", 
 headers: { 
 "content-type" : "application/json"
 }, 
  crossDomain: true,
 body: JSON.stringify({
 email,
 password
 })
 

 }) 
 
 const data = await response.json();
//  console.log(data,"data")
 // if(data==undefined){
 
 // }
 if(data.status== "ok"){ 
 setLoading(false)
 // console.log("Data",data);
 // console.log("Data",data.data);
 // var authData = data.data;
 // localStorage.setItem('tokem',data.user);
//  setAuth({user: email, roles : [data.data.role,"test role"], dat : data.data});
 // console.log("Email" ,email, "Role",data.data.role);
 // console.log("AUth",auth.user)
 alert("login successful!");
 // navigate("/dashboard");
 // navigate(from,{replace: true});
 } else{ 
 // alert("Unauthorized access") 
 setLoading(false);
 setMsg(data.msg)
 setErrorMsg(true);

 }
 
 }

 

 const handleAuthForm = () =>{
 
 setLogin(!loginState); 
 setRegister(!register);
 setForgotPwdStaten(false)
 
 }
 

 const handleAuthFormSec = () =>{
 
 setLogin(false); 
 setRegister(!register);
 setForgotPwdStaten(false)
 
 }
 
 const handleFOrgotPwd = () =>{
 setForgotPwdStaten(true)
 setLogin(false); 
 setRegister(false);
 
 }

 const handleSubmit = async (e) => {
 e.preventDefault();
 setLoading(true)
 setSuccessMsg(false);
 setErrorMsg(false);

 try {
 // console.log("email",email,"and",password)
 const response = await axios.post(process.env.REACT_APP_BASEURL+"/api/auth/login",
 JSON.stringify({ email, password }),
 // JSON.stringify({ user, pwd }),
 {
 headers: { 'Content-Type': 'application/json',
 // 'Origin': 'https://www.google.com/'
 // 'Origin': 'http://localhost:3000'
 },
 
 withCredentials: true,
 crossDomain: true,
// headers: {
// 'Origin': 'http://localhost:3000'
// }
 
 }
 );

//  console.log("response",response)

 if(response?.data.status== "Ok"){
 // if(response?.data?.accessToken !=""){
 // if(response?.data){

 // console.log("whole",JSON.stringify(response?.data));
 // console.log(JSON.stringify(response));
 const user = response?.data?.Userdata[0].Email;
 const accessToken = response?.data?.accessToken;
 const roles = response?.data?.Userdata[0].Role;
 const UserID = response?.data.Userdata[0].UserID;
 const FName = response?.data.Userdata[0].FName;
 const LName = response?.data.Userdata[0].LName;
 const Email = response?.data.Userdata[0].Email;
 const NRC = response?.data.Userdata[0].NRC;



   

 
//  const foundOrg = response?.data?.foundOrg;
 setAuth({});
 setAuth({ user, roles : [roles,"test role"], UserID,FName,LName,Email,NRC,accessToken, Role: roles});
//  setAuth({ user, roles : [roles,"test role"], accessToken, foundUser,foundOrg});
 // setAuth({});
 // setAuth({ user, pwd, roles, accessToken });
//  console.log("autheeeeee",auth)
 setUser('');
 setPwd('');
 navigate("/Home");

 }
 else {
//  console.log("test true")
 setLoading(false);
 setMsg(response.data.msg)
 setErrorMsg(true);

 }
 
 // navigate(from, { replace: true });
 } catch (err) {
 // if (!err?.response) {
 // setErrMsg('No Server Response');
 // } else if (err.response?.status === 400) {
 // setErrMsg('Missing Username or Password');
 // } else if (err.response?.status === 401) {
 // setErrMsg('Unauthorized');
 // } else {
 // setErrMsg('Login Failed');
 // }
 // // errRef.current.focus();
 }
 }

 ///Handle forgot submit
 const fgtPwdHandler = async (e) => {
 // e.preventDefault();
 e.preventDefault(); 
 setLoading(true)
 setSuccessMsg(false);
 setErrorMsg(false);
 
 const from = location?.state?.from?.pathname || "/UserDash";

 try {
 // console.log("email",email,"and",password)
 const response = await axios.post(process.env.REACT_APP_BASEURL+"/api/auth/UsrRecovery",
 JSON.stringify({ email, password }),
 // JSON.stringify({ user, pwd }),
 {
 headers: { 'Content-Type': 'application/json',
 // 'Access-Control-Allow-Credentials': 'true' ,
 // 'Origin': 'https://www.google.com/'
 // 'Origin': 'http://localhost:3000',
 'x-client-host': window.location.hostname
 },
 
//  withCredentials: true,
 crossDomain: true,
 
 }
 );
 // console.log("found ddagagdaorg")
 if(response?.data?.accessToken !=""){

 setForgotPwdStaten(false)
 setSucessRecovery(true)

 // console.log("whole",JSON.stringify(response?.data));
//  console.log(JSON.stringify(response));
 const user = response?.data?.email;
 const accessToken = response?.data?.accessToken;
 const roles = response?.data?.roles;
 const foundUser = response?.data?.foundUser;
 const foundOrg = response?.data?.foundOrg;
 // console.log("found org",foundOrg)
//  setAuth({});
//  setAuth({ user, roles : [roles,"test role"], accessToken, foundUser, foundOrg});
 // setAuth({ user, pwd, roles, accessToken });
 // console.log("autheeeeee",auth)
 setLoading(false)
 
 // alert("login successful!");
 // navigate("/dashboard");
 // navigate(from,{replace: true});

 }
 
 // navigate(from, { replace: true });
 } catch (err) {
 
 }
 }

 async function registerUser(e) { 
 e.preventDefault(); 
 setLoading(true);
 setSuccessMsg(false);
 setErrorMsg(false); 

//  console.log("selectedOption",selectedOption)

 if((selectedOption == "") || (selectedOption == "Gender") ){
         // console.log("in MALE true test")
         setLoading(false)
         setErrorMsg(true); 
         setMsg("Please Select Gender")
            
 }
 else if((Fname == "") && (Lname == "") && (Gender == "")&& (email == "")&& (password == "")&& (Phone == "")&& (NRC == "")){  

            // console.log("in field test")
            setLoading(false)
            setErrorMsg(true); 
            setMsg("Please fill in all fields")


 }

 else{        

   // console.log("in false test")

          const response = await fetch(process.env.REACT_APP_BASEURL+"/api/auth/register",{ 
 
                  method : "POST",
                  headers: { 
                  "content-type" : "application/json",
                  'Access-Control-Allow-Credentials': true
                  }, 

                  //  credentials: 'include'
                  //  ,
                  body: JSON.stringify({
                  // name,
                  // email,
                  // password,
                  // AccNo,
                  // Branch, 
                  Fname,
                  Lname,
                  Gender : selectedOption,
                  email,
                  password,
                  AccNo,
                  Branch,
                  OrgName,
                  Phone,
                  NRC

                  }),
                  

                  
                  

                  }) 

            const data = await response.json();
            // console.log(data);

           
            if(data.status == 'Ok'){
            // navigate("/login");
           // navigate("/Home");
            setLoading(false);
            setErrMsg(false)
            setSuccessMsg(true)
            setMsg(data.msg)
            
            handleAuthForm()
            }else{
            // alert("Operation Failed")
            setLoading(false);
            setMsg(data.msg)
            setErrorMsg(true);
            }

 }

 

 // const response = await fetch("https://superagentback.onrender.com/api/register",{ 
 // const response = await fetch("http://localhost:2001/api/authregister",{ 
//  const response = await fetch("https://unilus.com/Org",{ 



 }

 


 return( 

 <> <div className='LoginCoverContainer'>
 <div className="center">
 {loginState &&<>

 {/* <h1>Login</h1> */}
 <div className='formLogo'>
    <Link to={"/"} >  
             <img src={img1} />
    </Link>
        
 </div>
 {/* <form onSubmit={LoginUser}> */}
 <form onSubmit={handleSubmit}>
 <div className="txt_field">
 <input
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 type="email"
 // placeholder="Email"
 required
 />
 <span></span>
 <label>Email</label>

 </div>
 <div className="txt_field">

 <input
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 type="password"
 // placeholder="Password"
 required
 />

 <span></span>
 <label>Password</label>

 </div>

 
 
 {/* Loading Animation */}
 {Loading ?
 <div>
 <BeatLoader color="#36d7b7" />
 
 </div> : 
 <>
 <input type="submit" value="Login" />

 {successMsg && <div className="successMsgContainer">
 
 <p>{`${Msg}, Login!`}</p>
 
 </div>}

 {errorMsg && <div className="errorMsgContainer">
 
 <p>{`${Msg}`}</p>
 
 </div>}
 <div className="signup_link">
 New Applicant? <a href="#" onClick={handleAuthForm}>Signup</a>
 </div>
 <div className="signup_link">
 <a href="#" onClick={handleFOrgotPwd}>Forgot your password?</a>
 </div>

 </> 
 
 } 

 
 
 </form>

 </>}
 {forgotPwdState &&<>

 <h1>Account Recovery</h1>
 <form onSubmit={fgtPwdHandler}>
 <div className="txt_field">
 <input
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 type="email"
 // placeholder="Email"
 required
 />
 <span></span>
 <label>Email</label>

 </div>
 
 {/* Loading Animation */}
 {Loading ?
 <div>
 <BeatLoader color="#36d7b7" />
 
 </div> : 
 <>
 <input type="submit" value="Submit" />
 {successMsg && <div className="successMsgContainer">
 
 <p>{`${Msg}`}</p>
 
 </div>}

 {errorMsg && <div className="errorMsgContainer">
 
 <p>{`${Msg}`}</p>
 
 </div>}
 <div className="signup_link">
 Not Registered? <a href="#" onClick={handleAuthFormSec}>Signup</a>
 </div>

 </> 
 
 } 

 
 
 </form>

 </>}


 {sucessRecovery &&<>

 <h1>Account Recovery</h1>
 {/* <form onSubmit={fgtPwdHandler}> */}

 <p> We have sent you a mail to reset your <b>UNILUS</b> password.</p> 

 {/* <p>Click the Reset Password in that mail.</p> */}

 <p>If you didn't receive the reset password mail, please check the promotion/spam folder.</p> 
 
 
 
 {/* </form> */}

 </>}
 {register &&<>

 {/* <h1>Register</h1> */}
 <div className='formLogo'>
 <img src={img1} />
 </div>
 <form onSubmit={registerUser}>
 {/* Name */}
 <div className="txt_field">
 <input
 value={Fname}
 onChange={(e) => setFName(e.target.value)}
 type="text"
 required
 />
 <span></span>
 <label>First Name</label>

 </div>

  {/* AccountNumber */}
  <div className="txt_field">
 <input
 value={Lname}
 onChange={(e) => setLName(e.target.value)}
 type="text"
 required
 />
 <span></span>
 <label>Last Name</label>

 </div>

 {/* Email */}
 <div className="txt_field">
 <input
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 type="email"
 required
 />
 <span></span>
 <label>Email</label>

 </div>


 {/* Branch */}
 {/* <div className="txt_field">
 <input
 value={Branch}
 onChange={(e) => setBranch(e.target.value)}
 type="text"
 required
 />
 <span></span>
 <label>Your HQ</label>

 </div> */}
 {/* Email */}
 <div className="txt_field">
 {/* <input
 value={Gender}
 onChange={(e) => setGender(e.target.value)}
 type="text"
 required
 /> */}
            <div className='customdropdownCoverLogin'>
                  {/* <label htmlFor="dropdown">Select an option:</label> */}
                     <select id="dropdown" value={selectedOption} onChange={handleDropdownChange} className="customdropdownLogin">
                        <option value="">Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      
                     </select>

                     {/* <p>You selected: {selectedOption}</p> */}
                     </div>
 <span></span>
 {/* <label>Gender</label> */}

 </div>
 {/* NRC OR PASPOSE */}
 <div className="txt_field">
 <input
 value={NRC}
 onChange={(e) => setNRC(e.target.value)}
 type="text"
 required
 />
 

 <span></span>
 <label>NRC/Passport</label>

 </div>
 {/* Phonenumber */}
 <div className="txt_field">
 <input
 value={Phone}
 placeholder='e.g +260977000000'
 onChange={(e) => setPhone(e.target.value)}
 type="text"
 required
 />
 <span></span>
 <label>Phone Number</label>

 </div>
 {/* Password */}
 <div className="txt_field">
 <input
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 type="text"
 required
 />
 <span></span>
 <label>Password</label>

 </div>
 
 {/* <div className="txt_field">

 <input
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 type="password"
 // placeholder="Password"
 required
 />

 <span></span>
 <label>Password</label>

 </div> */}

 
 {Loading ?<div>
 
 <BeatLoader color="#36d7b7" />
 </div> : 
 <>
 <input type="submit" value="Sign Up" />
 
 
 {successMsg && <div className="successMsgContainer">
 
 <p>{`${Msg}`}</p>
 
 </div>}
 {errorMsg && <div className="errorMsgContainer">
 
 <p>{`${Msg}`}</p>
 
 </div>}
 

 <div className="signup_link">
 Already a member? <a href="#" onClick={handleAuthForm}>Sign in </a>
 </div>
 
 </>}
 
 
 
 </form>

 </>}
 
 </div>


   
 

 </div>
 </>
 )

}

export default Login;